import Vue from 'vue'
import Modal from './modal.vue'
import Icon from '../icon/icon.vue'
import TButton from '../button/button.vue'
import Locale from '../../mixins/locale'
const prefixCls = 'modal-confirm'
Modal.newInstance = properties => {
  const _props = properties || {}
  const div = document.createElement('div')
  div.innerHTML = `
    <Modal
        v-model="visible"
        :width="width"
        :scrollable="scrollable"
        @on-ok="onClickOk"
        @on-cancel="onClickCancel"
        :ok-text="localeOkText"
        :cancel-text="localeCancelText">
        <template slot>
          <div class="${prefixCls}-header">
            <div class="${prefixCls}-header-title" v-html="title"></div>
          </div>
          <div class="${prefixCls}-body">
           <div :class="iconTypeCls"><i :class="iconNameCls"></i></div>
           <div v-html="content"></div>
          </div>
        </template>
        <template slot="footer">
            <t-button type="secondary"  v-if="showCancel" @click.native="onClickCancel">{{ localeCancelText }}</t-button>
            <t-button type="primary" :loading="buttonLoading" @click.native="onClickOk">{{ localeOkText }}</t-button>
        </template>
    </Modal>
    `
  document.body.appendChild(div)
  let _data = {
    visible: false,
    content: '',
    icon: '',
    closable: false,
    maskClosable: false,
    footerHide: false,
    title: '',
    width: 416,
    height: '',
    okText: '',
    cancelText: '',
    showCancel: false,
    loading: false,
    buttonLoading: false,
    scrollable: false
  }
  for (let key in _props) {
    if (_data.hasOwnProperty(key)) {
      _data[key] = _props[key]
    }
  }
  const modal = new Vue({
    el: div,
    components: {Modal, TButton, Icon},
    mixins: [ Locale ],
    data: _data,
    computed: {
      confirmTitle () {
        return this.t(`t.modal.${this.icon}Title`)
      },
      iconTypeCls () {
        return [
          `${prefixCls}-body-icon`

        ]
      },
      iconNameCls () {
        if (!this.icon) {
          return ''
        }
        let _iconName = 'information text-info'
        switch (this.icon) {
          case 'info':
            _iconName = 'information text-info'
            break
          case 'success':
            _iconName = 'check-circle text-success'
            break
          case 'warning':
            _iconName = 'alert-circle text-warning'
            break
          case 'error':
            _iconName = 'close-circle text-danger'
            break
          case 'confirm':
            _iconName = 'help-circle text-warning'
            break
        }
        return [
          'aid',
          `aid-${_iconName}`
        ]
      },
      localeOkText () {
        if (this.okText) {
          return this.okText
        } else {
          return this.t('t.modal.okText')
        }
      },
      localeCancelText () {
        if (this.cancelText) {
          return this.cancelText
        } else {
          return this.t('t.modal.cancelText')
        }
      }
    },
    methods: {
      onClickCancel () {
        this.$children[ 0 ].visible = false
        this.buttonLoading = false
        this.onCancel()
        this.remove()
      },
      onClickOk () {
        if (this.loading) {
          this.buttonLoading = true
        } else {
          this.$children[ 0 ].visible = false
          this.remove()
        }
        this.onOk()
      },
      remove () {
        setTimeout(() => {
          this.destroy()
        }, 300)
      },
      destroy () {
        this.$destroy()
        document.body.removeChild(this.$el)
        this.onRemove()
      },
      onOk () {
        if (_props.onOk && typeof _props.onOk === 'function') {
          _props.onOk()
        }
      },
      onCancel () {
        if (_props.onCancel && typeof _props.onCancel === 'function') {
          _props.onCancel()
        }
      },
      onRemove () {
        if (_props.onRemove && typeof _props.onRemove === 'function') {
          _props.onRemove()
        }
      }
    }
  }).$children[ 0 ]
  return {
    show (props) {
      modal.$parent.visible = true
    },
    remove () {
      modal.$parent.visible = false
      modal.$parent.buttonLoading = false
      modal.$parent.remove()
    },
    component: modal
  }
}
export default Modal



// WEBPACK FOOTER //
// ./src/components/modal/confirm.js